import {Component, Injector} from '@angular/core';
import {PlayerContainer} from '../../player/player.container';
import {forkJoin, Observable, of, switchMap, takeUntil} from 'rxjs';
import {lastMap} from "../../rxjs/lastMap";
import {catchError, tap} from "rxjs/operators";

@Component({
  selector: 'app-scene',
  template: '<div #component><template #playercontainer></template></div>',
  styleUrls: []
})
export class SchedulerComponent extends PlayerContainer {
  scheduleEvents;
  loadType;
  loadId;
  scheduleId=-1;

  constructor(protected  injector: Injector) {
    super(injector);
  }

  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        if (this.data.Schedule[0]?.$?.id) {
          this.scheduleId = Number(this.data.Schedule[0].$.id);
        }
        if (this.editMode) {
          if (this.scheduleId!=-1) {
            return this.playerService.caching.getRecord("schedules", this.scheduleId).pipe(
              switchMap(schedule => {
                this.showMsg(schedule.schedule_name, schedule.description)
                return of(null);
              })
            )
          } else {
            this.showMsg("Schedule", "No schedule assigned");
            return of(null);
          }
        } else {
          if (this.scheduleId!=-1) {
            this.loadStat();

            this.scheduleEvents = this.playerService.createScheduleEvents(this.scheduleId);
            return this.scheduleEvents.load(this.scheduleId).pipe(
              switchMap(a => this.playLoop())
            )
          } else {
            return of(null);
          }
        }
      }),
      catchError(err => this.logError(err)),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }


  playLoop(): Observable<any> {
    const obs1$ = this.scheduleEvents.play();
    const eventName = "event_schedule_" + this.scheduleId;
    const obs2$ = this.playerService.eventParams.getEventParam(eventName).pipe(
      switchMap( param => {
        if (param.type=="scene" || param.type=="resource") {
          this.loadType = param.type;
          this.loadId = param.id;
          return this.showPage();
        } else {
          if (this.childComponent != null) {
            const duration = Number(((new Date().getTime() - this.statStart) / 1000).toFixed(2));
            this.childComponent.addContent(this.statTag, this.statFiled, duration);
            this.childComponent.destroy();
            this.removeComponent(this.childComponent);
          }
          this.childComponent = null;
          return of('complete')

        }
      })
    )

    return forkJoin([obs1$, obs2$]);
  }




  getPage(): Observable<any> {
    let player = null;
    if (this.loadType=="scene") {
      player = {$: {src: this.loadId}}
      return of(player);
    } if (this.loadType=="resource") {
      return this.playerService.caching.getRecord("resources", Number(this.loadId)).pipe(
        switchMap( resource => {
          if (resource != null) {
            player = {
              $: {
                player: (resource.resource_type == "mp4") ? 3100 : 3130,
                autoScaling: 1
              },
              Data: [{
                Resource: [{
                  $: {resource: this.loadId}
                }]
              }]
            }
            return of(player);
          }
        })
      )
    }

    return of(null);
  }

  destroy() {
    /*  will not destroy scheduleEvents cause it might be use    if (this.scheduleEvents!=null) {
      this.scheduleEvents.destroy();
      this.scheduleEvents = null;
    }

     */

    super.destroy();
  }
}
